import { createFileRoute, useParams } from "@tanstack/react-router";
import { useProject } from "@/hooks/use-project";
import { PlansView } from "@/components/plans/plans-view/plans-view";

interface PlansSearch {
  /** Deep link: open the plan viewer on this plan id once plans load. */
  plan?: string;
}

export const Route = createFileRoute("/projects/$projectId/plans/")({
  validateSearch: (search: Record<string, unknown>): PlansSearch => ({
    plan: typeof search.plan === "string" ? search.plan : undefined,
  }),
  component: PlansPage,
});

function PlansPage() {
  const { projectId } = useParams({
    from: "/projects/$projectId/plans/",
  });
  const { plan } = Route.useSearch();
  const { data: project } = useProject(projectId);

  if (!project) return null;

  return (
    <PlansView
      projectId={projectId}
      project={project}
      initialPlanId={plan ?? null}
    />
  );
}
